var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#FFECC9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2495 33.6539H21.1698L25.2843 28.2299L29.212 38.3294L33.514 26.5469L37.5348 39.4514L42.1173 33.6539H51.7495",
    stroke: "#FFA500",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcg);
export default __webpack_public_path__ + "static/media/Ecg.43cd30dee4bad6b6843a83e04814fe5c.svg";
export { ForwardRef as ReactComponent };